import { composeCreateCompositionActionMessage } from '@app/modules/compose/components/ComposeCreateCompositionLink';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import AddIcon from '@mui/icons-material/Add';
import { Box, Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

/**
 * Toolbar action that navigates to the create-composition screen for a station (AOD rules list pattern).
 */
export function CreateCompositionButton({ stationSlug }: { stationSlug: string }) {
  const { $t } = useIntl();

  return (
    <Box display="flex">
      <Button
        component={Link}
        to={composeRouteGenerator.createForStationSlug(stationSlug)}
        size="small"
        variant="outlined"
        startIcon={<AddIcon />}
      >
        {$t(composeCreateCompositionActionMessage)}
      </Button>
    </Box>
  );
}
